import { render, staticRenderFns } from "./CompensationGiftCards.vue?vue&type=template&id=446861bd&scoped=true"
import script from "./CompensationGiftCards.vue?vue&type=script&lang=js"
export * from "./CompensationGiftCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446861bd",
  null
  
)

export default component.exports